import * as React from 'react';
const Send = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-send", ...props },
    React.createElement("line", { x1: "22", y1: "2", x2: "11", y2: "13" }),
    React.createElement("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })));
export default Send;
//# sourceMappingURL=Send.js.map